import React from "react"

const Prose = ({ children }) => (
  <article className="
    prose prose-neutral prose-lg max-w-none dark:prose-invert dark:prose-hr:border-neutral-600 dark:prose-tr:border-neutral-600
    prose-headings:text-blue-900 dark:prose-headings:text-blue-300 prose-headings:font-display prose-headings:font-[400]
    font-[300] leading-relaxed prose-strong:font-[500] prose-strong:text-blue-950 dark:prose-strong:text-white
    prose-a:text-green-700 dark:prose-a:text-green-500
    ">
    {children}
  </article>
)

export default Prose
